<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title"><span class="title-red">Auto</span><span class="title-blue">Edge</span><span class="title-red">24</span> - Reifen</h3>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div id="iframe-wrapper" class="col-12">
            <iframe
              id="tiresIFrame"
              frameborder="0" 
              :width="iFrameWidth" 
              :height="iFrameHeight"
              :style="{zoom: iFrameZoom}"
              src="https://b2c.camodo.com/preisauskunft/de-DE/Reifen/Index?a=10107996&l=2&s=XpCy-E3Cr-EHBY-IsaE">
            </iframe>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h4 class="description">
              Brauchen Sie hilfe? Kontaktieren Sie uns einfach!<br>
              <n-button type="primary" round @click="openWhatsapp()">
                <span class="mdi mdi-whatsapp"></span> +49 176 55980480
              </n-button>
              <br>
              <n-button type="primary" round @click="openEmail()">
                <span class="mdi mdi-email-outline"></span> kontakt@autoedge24.de
              </n-button>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
import { Carousel, CarouselItem } from 'element-ui';

export default {
  name: 'shop',
  bodyClass: 'shop-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  mounted() {
    this.onResize()
    window.addEventListener("resize", this.onResize)
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize)
  },
  data() {
    return {
      iFrameWidth: "1000px",
      iFrameHeight: "1000px",
      iFrameZoom: 1.0,
      currentZoom: 1.0
    };
  },
  methods: {
    getPixelRatio() {
      let ratio = 1;
      // To account for zoom, change to use deviceXDPI instead of systemXDPI
      if (window.screen.systemXDPI !== undefined
            && window.screen.logicalXDPI !== undefined
            && window.screen.systemXDPI > window.screen.logicalXDPI) {
          // Only allow for values > 1
          ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
      } else if (window.devicePixelRatio !== undefined) {
          ratio = window.devicePixelRatio;
      }
      return ratio;
    },
    onResize() {
      //browserZoomLevel = Math.round(window.devicePixelRatio * 100);
      const zoomDetector = document.getElementById("zoomDetector")
      //const newZoom = zoomDetector.getBoundingClientRect().width
      const newZoom = this.getPixelRatio()
      const zoomChanged = newZoom != this.currentZoom
      //console.log("Zoom changed: " + zoomChanged + " New zoom: " + newZoom)

      const wrapper = document.getElementById("iframe-wrapper")
      let iFrameWidth = wrapper.clientWidth
      iFrameWidth = Math.min(iFrameWidth, 1000)

      //this.iFrameWidth = iFrameWidth + 'px'
      if (zoomChanged) {
        //this.currentZoom = newZoom
      }

      //this.iFrameZoom = Math.max(1.0, wrapper.clientWidth / 1000.0) - 0.01
      //this.iFrameZoom *= this.currentZoom
    },
    openPhone: function() {
      window.location = "tel:+4917655980480";
    },
    openWhatsapp: function() {
      window.open("https://wa.me/4917655980480", "_blank");
    },
    openEmail: function() {
      window.location = "mailto:kontakt@autoedge24.de";
    },
    zoomIn: function() {
      this.iFrameZoom += 0.1
    },
    zoomOut: function() {
      this.iFrameZoom -= 0.1
    }
  }
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}
.page-header{
  background-color: white !important;
}
.page-header::before{
  background-color: white !important;
}
.description {
  font-weight: normal;
}
.carousel-container {
  max-width: 800px !important;
}
#iframe-wrapper {
  text-align: center;
  width: 100%;
  overflow: scroll;
}

#zoomDetector {
  width: 1px;
  pointer-events: none;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
